import React, {useState} from 'react';
import Modal from '../../component/Inc/Modal';
import Tab from '../../component/Inc/Tab';
function PopRequestPoint(props) {
  const {open, close} = props;
  const tab = [
    {title: '포인트', value: 0},
    {title: '직급가점', value: 1}
  ];
  const [tabIdx, setTabIdx] = useState(0);

  return (
    <Modal open={open} close={close} type="com_input pop_point">
      <h2 className="pop_tit">포인트 & 직급가점 요청</h2>
      <div className="tab_wrap">
        <Tab data={tab} tab={tabIdx} setTab={setTabIdx} tabStyle="full" />
      </div>
      <div className="content_container scroll">
        {tabIdx === 0 ? (
          <section>
            <section className="search search_top">
              <input type="search" placeholder="교사명 검색" className="input s type_search" />
              <button className="com_btn gray ws s icon_search"></button>
            </section>
            <div className="attend_list">
              <p className="item">
                <button type="button" className="btn_close_x" onClick={() => {}}></button>
                <span className="txt">김참석12</span>
              </p>
              <p className="item">
                <button type="button" className="btn_close_x" onClick={() => {}}></button>
                <span className="txt">김참석12</span>
              </p>
            </div>
            <hr className="com_divider" />
            <div className="com_btn_wrap count_control">
              <button className="com_btn orange xs icon_plus"></button>
              <button className="com_btn lightGray xs icon_minus"></button>
            </div>
            <ul className="com_input_sec">
              <li className="tit_field">요청 사유 선택</li>
              <li className="input_field">
                <div className="com_input_wrap flex_column">
                  <select className="select">
                    <option value="사유 항목 선택">사유 항목 선택</option>
                  </select>
                  <select className="select">
                    <option value="사유 항목 상세 선택">사유 항목 상세 선택</option>
                  </select>
                </div>
              </li>
              <li className="tit_field type_flex">
                요청 포인트 입력 <button className="com_btn orange xs btn_plus">포인트 정책</button>
              </li>
              <li className="input_field">
                <input type="text" className="input input_point com_blue_txt" value="150" />
              </li>
              <li className="input_field">
                <textarea className="textarea" placeholder="요청 사유 입력"></textarea>
              </li>
            </ul>
          </section>
        ) : (
          <section>
            <section className="search search_top">
              <input type="search" placeholder="교사명 검색" className="input s type_search" />
              <button className="com_btn gray ws s icon_search"></button>
            </section>
            <div className="attend_list">
              <p className="item">
                <button type="button" className="btn_close_x" onClick={() => {}}></button>
                <span className="txt">김참석12</span>
              </p>
              <p className="item">
                <button type="button" className="btn_close_x" onClick={() => {}}></button>
                <span className="txt">김참석12</span>
              </p>
            </div>
            <hr className="com_divider" />
            <div className="com_btn_wrap count_control">
              <button className="com_btn orange xs icon_plus"></button>
              <button className="com_btn lightGray xs icon_minus"></button>
            </div>
            <ul className="com_input_sec">
              <li className="tit_field">요청 사유 선택</li>
              <li className="input_field">
                <div className="com_input_wrap flex_column">
                  <select className="select">
                    <option value="사유 항목 선택">사유 항목 선택</option>
                  </select>
                  <select className="select">
                    <option value="사유 항목 상세 선택">사유 항목 상세 선택</option>
                  </select>
                </div>
              </li>
              <li className="tit_field type_flex">
                요청 포인트 입력 <button className="com_btn orange xs btn_plus">직급가점 정책</button>
              </li>
              <li className="input_field">
                <input type="text" className="input input_point com_blue_txt" value="150" />
              </li>
              <li className="input_field">
                <textarea className="textarea" placeholder="요청 사유 입력"></textarea>
              </li>
            </ul>
          </section>
        )}
      </div>
      <div className="btn_container">
        <button className="com_btn orange xs">요청</button>
      </div>
    </Modal>
  );
}

export default PopRequestPoint;
